import { useState, useEffect } from 'react'
import { MessageSquare } from 'lucide-react'
import FeedbackModal from './FeedbackModal'

export default function FeedbackButton() {
  const [isModalOpen, setIsModalOpen] = useState(false)

  // Keyboard shortcut: Shift + F
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.shiftKey && e.key === 'F') {
        e.preventDefault()
        setIsModalOpen(true)
      }
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  return (
    <>
      <button
        onClick={() => setIsModalOpen(true)}
        className="
          btn-glass
          fixed bottom-6 left-6 z-50
          group
          flex items-center gap-3
          hover:scale-105
          active:scale-95
        "
        style={{ padding: 'var(--bbs-spacing-md) var(--bbs-spacing-xl)', borderRadius: 'var(--bbs-radius-md)' }}
        aria-label="Report bug or suggest feature"
        title="Report bug or suggest feature (Shift+F)"
      >
        {/* Icon with Jadeite glow */}
        <div className="relative">
          <div className="absolute inset-0 bg-[var(--bbs-jadeite-electric)] blur-md opacity-50 group-hover:opacity-75 transition-opacity" />
          <MessageSquare
            className="relative h-5 w-5 text-[var(--bbs-jadeite-electric)] drop-shadow-[0_0_6px_rgba(4,255,178,0.6)]"
            strokeWidth={2}
          />
        </div>

        {/* Label - slides in on hover */}
        <span className="
          font-medium
          text-sm
          text-[var(--bbs-text-primary)]
          opacity-0
          max-w-0
          group-hover:opacity-100
          group-hover:max-w-[200px]
          transition-all duration-300
          whitespace-nowrap
          overflow-hidden
        ">
          feedback
        </span>
      </button>

      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  )
}
